import Mock from 'mockjs' // 引入mockjs

const date_list = []
const selectConsultResult = []

function param2Obj(url) {
    const search = url.split('?')[1]
    if (!search) {
      return {}
    }
    return JSON.parse(
      '{"' +
        decodeURIComponent(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"') +
        '"}'
    )
  }

date_list.push(Mock.mock(
    {
        'time_slice':'上午(8：00至11：30)',
        'reserved_people':'2',
        'max_people': '30',
        'id':1
    }
))
date_list.push(Mock.mock(
    {
        'time_slice':'下午(2：00至5：30)',
        'reserved_people':'0',
        'max_people': '30',
        'id':2
    }
))

selectConsultResult.push(Mock.mock(
    {
        'date_time':'2021-01-04 下午',
        'contact_name|1': ['back', 'princelingg'],
        'contact_tel':'13828281919',
        'id':'2021010423'
    }
))

export default {
// 获取查档确认时间
getConsultTime: config =>{
    console.log(config)
    const { date_time } = param2Obj(config.url)
    if(date_time==''||date_time==null) {
        return {
            code: "204",
            data: [],
            msg: 'not find time!'
        }
    }
    return {
        code: "00",
        data: date_list
    }
},
// 查档预约提交信息
submitConsultFiles: config => ({
    code: "00",
    data: [JSON.parse(config.body)]
}),
// 查档预约查询
selectConsult: config =>{
    const { id_card } = param2Obj(config.url)
    if(id_card==''||id_card==null) {
        return {
            code: "204",
            data: [],
            msg: 'not find id_card!'
        }
    }
    return {
        code: "00",
        data: selectConsultResult
    }
},
// 参观预约取消
delConsult: config =>{
    const { id } = param2Obj(config.url)
    if(id==''||id==null) {
        return {
            code: "204",
            data: [],
            msg: 'not find id!'
        }
    }
    return {
        code: "99",
        data: '成功取消预约！'
    }
},
  // look
//   getOrgList: () => {
//     return {
//       total: List.length,
//       data: List
//     }
//   },
//   // add
//   createOrg: () => ({
//     resultCode: 200,
//     data: 'success'
//   }),
//   // edit
//   updateOrg: () => ({
//     resultCode: 200,
//     data: 'success'
//   }),
//   // delete
//   orgDelete: () => ({
//     resultCode: 200,
//     data: 'success'
//   }),
//   getTaskCategory:() => {
//     return {
//       total: 2,
//       data: 'test'
//     }
//   }
}